import API from '../api/api';

export type AccountSettings = {
  companyName: string;
  timezone: string;
  postalAddress: {
    country: string;
    city: string;
    state: string;
    street: string;
    street2: string;
    zipcode: string;
  };
};

export interface IRelationshipType {
  id: number;
  accountId: string;
  externalId: string;
  name: string;
  isFamily: boolean;
  isDeleted: boolean;
  createdAt: Date;
  updatedAt?: Date | null;
}

export interface IRelationshipTypeGetParam {
  isFamily?: boolean;
  isDeleted?: boolean;
}

export interface IAccountService {
  getAccountSettings(accountId: string): Promise<AccountSettings>;
}

export class AccountService implements IAccountService {
  public async getAccountSettings(accountId: string): Promise<AccountSettings> {
    const response = await API().get(`/account/v1/public/accounts/${accountId}/settings`);

    return response.data;
  }

  public async getRelationshipTypes(
    accountId: string,
    params: IRelationshipTypeGetParam
  ): Promise<IRelationshipType[]> {
    const response = await API().get(
      `/account/v1/public/accounts/${accountId}/relationship-types`,
      { params }
    );

    return response?.data || [];
  }
}

export default new AccountService();
